import React from 'react';
import { COSTAL_COPY, COSTAL_RECIPES } from '../constants/costalRecipes';
import './CostalComunidadPage.css';

const go = (path) => {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

const CostalComunidadPage = () => {
  return (
    <div className="costal-comunidad">
      <section className="costal-com-hero">
        <div className="costal-com-wrap">
          <p className="costal-com-kicker">Comunidad</p>
          <h1>La receta es el punto de encuentro.</h1>
          <p className="costal-com-lead">
            {COSTAL_COPY.promise} {COSTAL_COPY.tagline} Acá están las recetas A, B y C — cada una se arma
            completa en la tienda.
          </p>
          <div className="costal-com-actions">
            <button type="button" className="costal-com-btn costal-com-btn--solid" onClick={() => go('/tienda')}>
              Ir a la tienda
            </button>
            <button
              type="button"
              className="costal-com-btn costal-com-btn--ghost"
              onClick={() => go('/comunidad/ingresar')}
            >
              Ingresar
            </button>
          </div>
        </div>
      </section>

      <section className="costal-com-list">
        <div className="costal-com-wrap">
          {COSTAL_RECIPES.map((recipe) => (
            <article key={recipe.id} className={`costal-recipe costal-recipe--${recipe.id}`} id={`receta-${recipe.id}`}>
              <header className="costal-recipe-head">
                <span className="costal-recipe-letter">{recipe.letter}</span>
                <div>
                  <p className="costal-com-kicker">{recipe.kicker}</p>
                  <h2>{recipe.name}</h2>
                  <p className="costal-recipe-lead">{recipe.lead}</p>
                </div>
              </header>

              <p className="costal-recipe-method">{recipe.method}</p>

              <div className="costal-recipe-skus">
                <p className="costal-recipe-skus-label">La tienda de esta receta</p>
                <ul>
                  {recipe.skus.map((sku) => (
                    <li key={`${recipe.id}-${sku.id}`}>
                      <button type="button" onClick={() => go(`/producto/${sku.id}`)}>
                        <span>{sku.name}</span>
                        <span>{sku.price}</span>
                      </button>
                    </li>
                  ))}
                </ul>
                <p className="costal-recipe-pvp">
                  Lista completa: <strong>{recipe.pvp}</strong>
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="costal-com-close">
        <div className="costal-com-wrap">
          <h2>El costal se abre en casa.</h2>
          <p>
            Combo Costal es una lista de compra, no un kit que aparta bodega. Elegí suelto o armá la receta
            completa — el stock es el que hay.
          </p>
          <button type="button" className="costal-com-btn costal-com-btn--solid" onClick={() => go('/tienda')}>
            Abrir la tienda
          </button>
        </div>
      </section>
    </div>
  );
};

export default CostalComunidadPage;
